<template>
  <div id="ReviewQuestion">
    <div v-if="areReviewQuestionsLoading" class="d-flex justify-content-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else-if="reviewSet && reviewSet.length" class="review-list">
      <div
        v-for="(item, index) in reviewSet"
        :key="index"
        class="review-item-container"
      >
        <div class="review-item">
          <p class="question" v-if="item.question">{{ item.question }}</p>
          <p class="answer" v-if="item.answer && isAnswerString(item.answer)">
            {{ item.answer }}
          </p>
          <div v-else-if="item.answer">
            <p v-for="(value, key) in item.answer" :key="key" class="answer">
              {{ value }}
            </p>
          </div>
        </div>
        <button class="btn-edit" @click="editQuestion(item.question_id)">
          <span>Edit</span>
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ReviewQuestion",
  props: ["questionHistory", "setAnswer", "question", "bookingJourneyId", "apiQuestionnaire", "onEditQuestion", "userId"],
  data() {
    return {
      reviewSet: null,
      areReviewQuestionsLoading: false
    };
  },
  mounted() {
    this.setAnswer(this.questionHistory);
    this.getReviewQuestions();
  },
  methods: {
    isAnswerString(answer) {
      return typeof answer === "string";
    },
    editQuestion(questionId) {
      console.log("editQuestion", questionId)
      this.onEditQuestion?.(questionId);
    },
    async getReviewQuestions() {
      if (this.areReviewQuestionsLoading) return;
      try {
        this.areReviewQuestionsLoading = true;
        const payload = {
          user_id: this.userId,
          service_type: "vpc",
          current_question_id: this.question.question_id,
          questions_ids: this.questionHistory,
          booking_journey_id: this.bookingJourneyId,
        };
        const res = await this.apiQuestionnaire.getReviewQuestions(payload);
        if (res.data.success) {
          this.reviewSet = res.data.review_set;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.areReviewQuestionsLoading = false;
      }
    }
  }
};
</script>

<style lang="less">
#ReviewQuestion {
  .review-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 0 auto;
  }

  .review-item-container {
    max-width: 100%;
    width: 100%;
    display: flex;
    gap: 18px;
    justify-content: center;
    align-items: flex-start;
  }

  .review-item {
    flex: 1 1 70%;
    max-width: 80%;
    border: 1px solid #aeb0bd;
    padding: 16px;
    border-radius: 12px;
  }

  .question {
    color: #797b89;
    font-family: var(--font-bold, "DMSans Bold") !important;
    font-size: 1.4rem;
    padding: 0;
    margin-bottom: 10px;
  }

  .answer {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    color: #1e1e22;
    font-size: 1.6rem;
    font-family: var(--font-regular, "DMSans");
    padding: 0;
    margin: 0;
  }

  .btn-edit {
    flex: 0 0 98px;
    width: 98px;
    background-color: rgba(30, 30, 34, 0.05);
    border-radius: 5px;
    padding: 16px 24px;
    color: #1e1e22;
    font-family: var(--font-bold, "DMSans Bold");
    font-size: 1.4rem;
    border: 0;

    .fa {
      color: #1e1e22;
      font-size: 1.4rem;
      margin-left: 8px;
    }
  }
}
</style>
